/** Do not edit directly **/
/** Do not edit directly **/
/**
 * @prop --sy-grid-pattern: [PENDING DOC]
 * @prop --sy-grid-gutter-size: [PENDING DOC]
 * @prop --sy-grid-alignment: [PENDING DOC]
 * @prop --sy-grid-count: [PENDING DOC]
 * @prop --sy-grid-offset: [PENDING DOC]
 * @prop --sy-grid-max-width-xs: Grid max width xs.
 * @prop --sy-grid-max-width-sm: Grid max width sm.
 * @prop --sy-grid-max-width-md: Grid max width md.
 * @prop --sy-grid-max-width-lg: Grid max width lg.
 * @prop --sy-grid-max-width-xl: Grid max width xl.
 * @prop --sy-grid-max-width-xxl: Grid max width xxl.
 * @prop --sy-grid-gap: Grid gap - It must be a single number value and defines both row and column gap
 * @prop --sy-grid-row-gap: Grid row gap.
 * @prop --sy-grid-column-gap: Grid column gap.
 */
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: flex;
  flex-wrap: wrap;
  min-width: 0;
  margin-right: calc(var(--sy-grid-column-gap, var(--sy-grid-gap, var(--sy-spacer-5))) * -.5);
  margin-left: calc(var(--sy-grid-column-gap, var(--sy-grid-gap, var(--sy-spacer-5))) * -.5);
  row-gap: var(--sy-grid-row-gap, var(--sy-grid-gap, var(--sy-spacer-5)));
}